// extracted by mini-css-extract-plugin
export default {"mergeDetails":"MergeDetails_mergeDetails__zYzhY"};